import { createTheme } from '@mui/material/styles';

// Palette tokens pulled from src/plugins/vuetify.js plus the hardcoded colors
// found repeated ad hoc across components (see migration plan). Kept in one
// place so future ported views normalize onto these instead of re-hardcoding.
export const muiTheme = createTheme({
  palette: {
    primary: { main: '#2c6b87' },
    secondary: { main: '#9F2B00' },
    error: { main: '#FF5252' },
    info: { main: '#2196F3' },
    success: { main: '#4CAF50' },
    warning: { main: '#FFC107' },
  },
});

// Vuetify's non-standard custom theme key + other recurring hardcoded tokens
// that have no direct MUI palette slot.
export const customTokens = {
  navBarColor: '#1976D2',
  accentScrollbar: '#d37444',
  slate: { 900: '#111827', 800: '#1f2937', 700: '#374151', 200: '#e5e7eb', 50: '#f8fafc' },
  blue: { 900: '#0a2650', 800: '#173a69', 700: '#1565c0', 50: '#f4f7fb' },
};
